import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import "chart.js/auto";
import "./DonutChart.css";

const DonutChart = ({ data, colors }) => {
  const [showMore, setShowMore] = useState(false);

  // Convert string data to numbers and filter out zeros
  
  const filteredData = data.datasets[0].data
    .map((value, index) => ({
      value: Number(value),
      label: data.labels[index],
      color: colors[index],
      count: data.counts?.[index] ?? 0,
    }))
    .filter((item) => item.value !== 0);

  // Prepare chart data
  const chartData = {
    labels: filteredData.map((item) => item.label),
    datasets: [
      {
        data: filteredData.map((item) => item.value),
        backgroundColor: filteredData.map((item) => item.color),
        hoverBackgroundColor: filteredData.map((item) => item.color),
        borderWidth: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            const label = tooltipItem.label || "";
            const value = tooltipItem.raw || 0;
            const index = tooltipItem.dataIndex; 
            const count = filteredData[index]?.count ?? 0;
            return `${label}: ${value}% (Episodes: ${count})`;
          },
        },
      },
      legend: {
        display: false,
      },
    },
  };

  const toggleShowMore = () => setShowMore(!showMore);

  // Control how many items to show in the legend
  // const legendItems = showMore
  //   ? filteredData
  //   : filteredData.slice(0, 25);

    const legendItems = filteredData;


  return (
    <div style={{ height: "70%" }}>
      <div style={{ height: "70%" }}>
        <Doughnut data={chartData} options={options} />
      </div>

      <ul className="list-donut" style={{ padding: 8 }}>
        {legendItems.map((item, index) => (
          <li
            key={index}
            style={{
              marginBottom: "5px",
              listStyleType: "none",
              display: "flex",
              alignItems: "center",
              fontSize: "10px",
            }}
          >
            <span
              style={{
                display: "inline-block",
                width: "15px",
                height: "15px",
                backgroundColor: item.color,
                marginRight: "10px",
                borderRadius: "50%",
              }}
            ></span>
            {item.label}
          </li>
        ))}
      </ul>

      {false && filteredData.length > 25 && (
        <div
          onClick={toggleShowMore}
          style={{ cursor: "pointer" }}
          className="expand-arrow"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            viewBox="0 0 16 16"
          >
            <path d="M3.204 5h9.592L8 10.481zm-.753.659 4.796 5.48a1 1 0 0 0 1.506 0l4.796-5.48c.566-.647.106-1.659-.753-1.659H3.204a1 1 0 0 0-.753 1.659" />
          </svg>
        </div>
      )}
    </div>
  );
};

export default DonutChart;
